import * as React from 'react';

import classnames from 'classnames';

import {ChevronLeftIcon} from '../../icon';

import styles from './back-button.module.css';

type Props = {
    backText: string;
    as: string | React.ComponentType<any>;
    getRef?: any;
    to?: string;
};

export function BackButton(props: Props) {
    const {as = 'button', backText = 'Back', getRef, ...restProps} = props;

    const Component = as;
    const htmlProps = Component === 'button' ? {type: 'button', ...restProps} : restProps;

    return (
        <Component
            {...htmlProps}
            ref={getRef}
            // @ts-expect-error
            className={classnames(styles.container, htmlProps?.className)}
        >
            <ChevronLeftIcon /> &nbsp;{backText}
        </Component>
    );
}
